"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9775,289],{

/***/ 90182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ FOOTER_NAV_SOCIAL; },
/* harmony export */   "h2": function() { return /* binding */ FOOTER_NAV_GROUPS; },
/* harmony export */   "vN": function() { return /* binding */ FOOTER_NAV_SECONDARY; }
/* harmony export */ });
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97143);
/* harmony import */ var features_job_offers_list_components_JobOffersListComponent_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82324);
/* harmony import */ var components_shared_XTwitterIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66334);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62177);
/* harmony import */ var utils_job_offers_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55920);
/* harmony import */ var utils_localize_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38062);






var FOOTER_NAV_GROUPS = function(t, locale) {
    return [
        {
            title: t("nav.talentTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.talent */ .uu.talent, locale)),
                    title: t("nav.product")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.manfredDaily */ .uu.manfredDaily, locale)),
                    title: t("nav.telegramOffers")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.jobOffers */ .uu.jobOffers, locale), "?").concat((0,utils_job_offers_filter__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParamsFromJobOffersFilter */ .Ci)(features_job_offers_list_components_JobOffersListComponent_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_FILTER */ .XW, (0,utils_localize_utils__WEBPACK_IMPORTED_MODULE_4__/* .getLocale */ .K)(locale))),
                    title: t("nav.offers")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.salaryCompass */ .uu.salaryCompass, locale)),
                    title: t("nav.salaryCompass")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.roles */ .uu.roles, locale)),
                    title: t("nav.roles")
                }
            ]
        },
        {
            title: t("nav.companiesTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.companies */ .uu.companies, locale)),
                    title: t("nav.services")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.yourOfferSalary */ .uu.yourOfferSalary, locale)),
                    title: t("nav.yourOfferSalary")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.hrAsAService */ .uu.hrAsAService, locale)),
                    title: t("nav.hr-as-a-service")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.manfredDailyCompanies */ .uu.manfredDailyCompanies, locale)),
                    title: t("nav.daily")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.outOfOffice */ .uu.outOfOffice, locale)),
                    title: t("nav.outOfOffice")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.helpingCompanies */ .uu.helpingCompanies, locale)),
                    title: t("nav.helpingCompanies")
                }
            ]
        },
        {
            title: t("nav.knowledgeTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.blog */ .uu.blog, locale)),
                    title: t("nav.blog")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.mantechcar25 */ .uu.mantechcar25, locale)),
                    title: t("nav.stateOfTheSector")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.hiringProcessComparison */ .uu.hiringProcessComparison, locale)),
                    title: t("nav.hiringProcessComparison")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.helpingJuniors */ .uu.helpingJuniors, locale)),
                    title: t("nav.helpingJuniors")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.stateOfHiring */ .uu.stateOfHiring, locale)),
                    title: t("nav.hiringReport")
                }
            ]
        },
        {
            title: t("nav.manfredTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.team */ .uu.team, locale)),
                    title: t("nav.us")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.blog */ .uu.blog, locale), "/compromiso-etico-manfred"),
                    title: t("nav.ethicalCommitment")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.battleReport */ .uu.battleReport, locale)),
                    title: t("nav.battleReport")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.joinUs */ .uu.joinUs, locale)),
                    title: t("nav.joinUs")
                }
            ]
        }
    ];
};
var FOOTER_NAV_SECONDARY = function(t, locale) {
    return [
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.termsOfUse */ .uu.termsOfUse, locale)),
            title: t("nav.terms")
        },
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.privacyPolicy */ .uu.privacyPolicy, locale)),
            title: t("nav.privacy")
        },
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.cookies */ .uu.cookies, locale)),
            title: t("nav.cookies")
        }
    ];
};
var FOOTER_NAV_SOCIAL = function() {
    return [
        {
            title: "X",
            href: "https://x.com/getmanfred",
            icon: components_shared_XTwitterIcon__WEBPACK_IMPORTED_MODULE_1__/* .faXTwitter */ .N
        },
        {
            title: "Twitch",
            href: "https://www.twitch.tv/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTwitch */ .z0T
        },
        {
            title: "LinkedIn",
            href: "https://es.linkedin.com/company/manfred/",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faLinkedin */ .D9H
        },
        {
            title: "GitHub",
            href: "https://github.com/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faGithub */ .zhw
        },
        {
            title: "Telegram",
            href: "https://t.me/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTelegramPlane */ .IKq
        }
    ];
};


/***/ }),

/***/ 96088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ StyledPage; },
/* harmony export */   "PQ": function() { return /* binding */ StyledContainer; },
/* harmony export */   "nz": function() { return /* binding */ GlobalStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :root {\n    --out-of-office-blue: #0B50B5;\n    --out-of-office-yellow: #FFD514;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  min-height: 100vh;\n\n  > img {\n    width: 100%;\n    @media (max-width: ",
        ") {\n      &.desktop {\n        display: none;\n      }\n    }\n    @media (min-width: ",
        ") {\n      &.mobile {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n  min-height: 100vh;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var GlobalStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .createGlobalStyle */ .vJ)(_templateObject());
var StyledPage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].main.withConfig */ .ZP.main.withConfig({
    componentId: "sc-6c808b7e-0"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_100"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("navy_700"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("mdMax"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"));
var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6c808b7e-1"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .container */ .nC)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));


/***/ }),

/***/ 91153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/footer/Footer.constants.tsx
var Footer_constants = __webpack_require__(90182);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/footer/Footer.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  background-color: var(--out-of-office-blue);\n  clip-path: polygon(0 5rem, 100% 0, 100% 100%, 0% 100%);\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    clip-path: polygon(0 10rem, 100% 0, 100% 100%, 0% 100%);\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  img {\n    display: block;\n    width: auto;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active,\n  &.active {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  ul {\n    display: flex;\n    gap: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active,\n  &.active {\n    color: ",
        ";\n  }\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-b30f967a-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl7"));
var StyledFooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b30f967a-1"
})(_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledFooterMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b30f967a-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"));
var StyledFooterLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b30f967a-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl2"));
var StyledFooterCopyright = styled_components_browser_esm/* default.small.withConfig */.ZP.small.withConfig({
    componentId: "sc-b30f967a-4"
})(_templateObject4(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("white"));
var StyledFooterNavItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b30f967a-5"
})(_templateObject5(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"));
var StyledFooterNavCopy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b30f967a-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("white"));
var StyledFooterSecondary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b30f967a-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"), StyledFooterNavItem, (0,theme/* fontSize */.JB)("xs"));
var StyledFooterSocial = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b30f967a-8"
})(_templateObject8(), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("mdlg"));

;// CONCATENATED MODULE: ./components/marketingSite/outOfOffice/sections/footer/Footer.tsx









var Footer = function() {
    var ref = (0,react.useState)(null), year = ref[0], setYear = ref[1];
    var t = (0,useI18n/* useI18n */.Q)("footer").t;
    var locale = (0,router.useRouter)().locale;
    (0,react.useEffect)(function() {
        setYear(new Date().getFullYear());
    }, []);
    var footerNavSecondary = (0,Footer_constants/* FOOTER_NAV_SECONDARY */.vN)(t, locale);
    var footerNavSocial = (0,Footer_constants/* FOOTER_NAV_SOCIAL */.Rw)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterMain, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterLogo, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: logos/* LOGO_MANFRED_WHITE */.YM,
                                alt: "Manfred logo",
                                width: "132",
                                height: "24"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterNavCopy, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterCopyright, {
                                children: [
                                    "\xa9 ",
                                    year,
                                    " ",
                                    t("nav.manfredTech")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterSecondary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: footerNavSecondary.map(function(navItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: navItem.href,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterNavItem, {
                                                        children: navItem.title
                                                    })
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: footerNavSocial.map(function(navItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterSocial, {
                                                    title: navItem.title,
                                                    href: navItem.href,
                                                    target: "_blank",
                                                    rel: "noreferrer noopener",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: navItem.icon
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer = (Footer);


/***/ }),

/***/ 90504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UO": function() { return /* binding */ StyledLogoManfred; },
/* harmony export */   "eb": function() { return /* binding */ StyledHeader; },
/* harmony export */   "ps": function() { return /* binding */ StyledLogo; },
/* harmony export */   "xL": function() { return /* binding */ StyledIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90637);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    font-family: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.6;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 12.5rem;\n  margin: 0 auto ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: 20rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  padding-left: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: left;\n\n  @media (min-width: ",
        ") {\n    padding-left: ",
        ";\n  }\n\n  img {\n    height: 35px;\n\n    @media (min-width: ",
        ") {\n      height: 47px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    @media (min-width: ",
        ") {\n      width: ",
        ";\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c138a13f-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("mdlg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), components_shared_Typography_styled__WEBPACK_IMPORTED_MODULE_1__/* .Heading1 */ .nL, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontFamily */ .I8)("sans"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xl"));
var StyledLogo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c138a13f-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"));
var StyledLogoManfred = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c138a13f-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl3"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"));
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c138a13f-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl5"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl5"));


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 66334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ faXTwitter; },
/* harmony export */   "n": function() { return /* binding */ XTwitterIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);



var faXTwitter = {
    prefix: "fab",
    iconName: "x-twitter",
    icon: [
        512,
        512,
        [],
        "f099",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 240.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var XTwitterIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        icon: faXTwitter
    }, props));
};


/***/ }),

/***/ 82324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ DEBOUNCE_FILTER_OFFERS_TIME_IN_MILLIS; },
/* harmony export */   "E0": function() { return /* binding */ OPEN_ALERT_PARAM; },
/* harmony export */   "P4": function() { return /* binding */ UNSUSCRIBE_ALERT_PARAM; },
/* harmony export */   "XW": function() { return /* binding */ DEFAULT_FILTER; },
/* harmony export */   "ge": function() { return /* binding */ LOADING_AFTER_MILLIS; }
/* harmony export */ });
var LOADING_AFTER_MILLIS = 250;
var DEFAULT_FILTER = {
    onlyActive: true,
    text: "",
    currency: "€",
    locations: [],
    remoteOptions: [],
    techs: [],
    techRoles: [],
    minSalary: "",
    offerLanguage: "",
    minLanguages: []
};
var OPEN_ALERT_PARAM = "open-alerts";
var UNSUSCRIBE_ALERT_PARAM = "unsuscribe-alert";
var DEBOUNCE_FILTER_OFFERS_TIME_IN_MILLIS = 350;


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ })

}]);